import { theme } from '../Theme';
import React, { useEffect } from 'react';
import { styled } from 'linaria/react';

import MaxWidth from '../Layout/MaxWidth';
import LoadingPage from '../LoadingPage';
import StartPageProductGrid from './Content/StartPageProductGrid';
import startPageQuery from './StartPageQuery.gql';
import { useQuery } from 'react-apollo';

import StartPageRenderer from '@jetshop/ui/StartPageRenderer';
import { allComponents } from './ContentRendererComponents/allcomponents';
import { useTracking } from '../../utils/tracking/useTracking';
import { PAGE_TYPES } from '../../utils/tracking/constants';
import { ElevateRecommendedProducts } from './ContentRendererComponents/ElevateRecommendedProducts';

const StartPageWrapper = styled('div')`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export const MainSectionWrapper = styled(MaxWidth)`
  width: 100%;
  align-self: center;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  ${theme.below.sm} {
    padding-left: 0px;
    padding-right: 0px;
  }
`;

const StartPage = ({ startPageId }) => {
  const { trackPageView } = useTracking();
  const result = useQuery(startPageQuery, {
    variables: { startPageId: startPageId }
  });
  const { loading } = result;

  // Route changes keep the current scroll position because global scroll
  // restoration is disabled. Reset home navigation to the top, but leave
  // hash links alone so browser/anchor navigation can position the page.
  useEffect(() => {
    if (typeof window !== 'undefined' && !window.location.hash) {
      window.scrollTo(0, 0);
    }
  }, []);

  // Track page view
  useEffect(() => {
    if (!loading && result?.data) {
      trackPageView({
        pageType: PAGE_TYPES.HOME,
        pagePath: '/',
        pageTitle: typeof document !== 'undefined' ? document.title : 'Hööks'
      });
    }
  }, [loading, result?.data, trackPageView]);

  if (loading || !result?.data || result?.data?.data) return <LoadingPage />;

  return (
    <StartPageWrapper>
      <StartPageRenderer
        result={result}
        startPageComponents={allComponents}
        LoadingPage={LoadingPage}
        ProductGrid={StartPageProductGrid}
      />
    </StartPageWrapper>
  );
};

export default StartPage;
